// A map to store author IDs and their corresponding names.
// This is much easier to maintain than a long if/else chain.
const authorMap = {
  '646cecba067791000857c2b2': 'Marissa Ricco',
  '654959fbe60e1d000882ae19': 'Ronnie Bermejo',
  '668505e2328da0e2573f97a3': 'Mariano Romero',
  '646cfca9067791000857c2b6': 'Gerardo Malo'
};

/**
 * Generates a BlogPosting schema from an article object.
 * @param {object} article - The article object from your database.
 * @returns {object|null} A valid BlogPosting schema object, or null if essential data is missing.
 */
export function blogPostSchemaGenerator(article) {
  // Guard clause: If there's no article or no title, we can't create a valid schema.
  if (!article || !article.title) {
    return null;
  }

  // Look up the author name from the map. Default to 'Tulum.Party Staff' if not found.
  const authorName = authorMap[article.created_by] || 'Tulum.Party Staff';

  // Use optional chaining (?.) to safely access nested properties and provide fallbacks.
  const imageUrl = article.metadata?.cover?.imgix_url || 'https://www.tulum.party/default-image.jpg'; // Fallback image

  function cleanContent() {
    const shortDescription =  article.content;
    if (!shortDescription) {
      return undefined; // Or a default description if you prefer
    }
    // Remove HTML tags, replace non-breaking spaces, then trim
    const cleaned = shortDescription
      .replace(/(<([^>]+)>)/gi, "")
      .replace(/\u00A0/gi, " ") // \u00A0 is the non-breaking space
      .trim();

    // Truncate and add ellipsis
    // if (cleaned.length > 550) {
    //   return cleaned.substring(0, 550) + "…"; // substring is generally preferred over substr
    // }
    return cleaned;
  }

  return {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": `https://www.tulum.party/article/${article.slug}` // Assumes article has a slug property
    },
    "image": {
      "@type": "ImageObject",
      "url": imageUrl + '?w=1200&h=675&fit=clamp',
      "width": 1200,
      "height": 675
    },
    "headline": article.title,
    "datePublished": article.published_at, // Assumes this is an ISO 8601 format string
    "dateModified": article.updated_at, // Assumes this is an ISO 8601 format string
    "author": {
      "@type": "Person",
      "name": authorName,
    },
    "description": article.metadata.caption,
    "articleBody": cleanContent(),
    "publisher": {
      "@type": "Organization",
      "name": "tulum.party",
      "logo": {
        "@type": "ImageObject",
        "url": "https://imgix.cosmicjs.com/3acdf350-9b87-11ee-b34c-99d1d89e42eb-tp-logo-40pt.png"
      }
    }
  };
}
